import {animated, useSpring} from "@react-spring/web";
import userImage from "../../assets/Remote_Experts.png";
import loading from "../../assets/loading.gif";

export const AnswerLoading = () => {
    const animatedStyles = useSpring({
        from: {opacity: 0},
        to: {opacity: 1}
    });

    return (
        <>
            <div className="flex flex-row items-start gap-2.5">
                <img className="w-8 h-8 rounded-full bg-white border " src={userImage} alt="user image"/>
                <div
                    className="flex flex-col w-full max-w-lg leading-1.5 p-4 border-gray-200 shadow-sm rounded-xl rounded-tl-sm bg-white border  animate-pulse">
                    <span className="text-sm font-semibold text-gray-900">WEINIG LifeTime Service Assistent</span>

                    <p className="text-sm font-normal py-1 text-red-500 "></p>
                    <img className="w-14 h-14  -m-2" src={loading} alt="user image"/>
                </div>
            </div>
        </>
    );
};
